import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

import { size, styleUtils } from '@twisto/styles'
import type { CurrencyPosition } from '@twisto/utils'

export const text = (theme: Theme, position: CurrencyPosition) => css`
  color: ${theme.palette.neutral['700']};
  font-weight: ${styleUtils.fontWeight.medium};
  font-size: 16px;
  line-height: 24px;
  margin-left: ${position === 'end' ? size[8] : 0};
  margin-right: ${position === 'start' ? size[8] : 0};
`

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.neutral['600']};
`
